export default __webpack_public_path__ + "static/media/wprime.b3a6a0bf.png";